import { useEffect, useState } from "react";
import { Spinner } from 'react-bootstrap';

import { Validators } from "../../../shared/utils/Validators";
import { TextAreaInput, TextInput } from "../../../shared/form/FormInput";
import Select from 'react-select';
import { clientDetail, clientsAdd, sitesList } from "../../../shared/settings/apiConfig";
import { getApi, postApi, putApi } from "../../../shared/services/apiHelper";

import './ClientAddEdit.scss';
import { ClientIcon, BuildingIcon, PhoneIcon, EmailIcon, FileTextIcon, LocationIcon, UserIcon, PlusIcon } from "../../../shared/icons/Icons";

export const ClientAddEdit = (props) => {

    const isEdit = props.location.pathname.includes('edit');
    const clientId = props.location.pathname.includes('add') ? '' : props?.match?.params?.id;

    const [initialLoading, setInitialLoading] = useState(isEdit);
    const [sites, setSites] = useState([]);
    const [clientForm, setClientForm] = useState({
        name: { value: '', valid: false, error: '', validators: [Validators.required()] },
        company_name: { value: '', valid: false, error: '', validators: [Validators.required()] },
        site_id: { value: '', valid: false, error: '', validators: [Validators.required()] },
        mobile: { value: '', valid: false, error: '', validators: [Validators.required(), Validators.phoneNumberValid()] },
        email: { value: '', valid: false, error: '', validators: [Validators.required()] },
        gstnumber: { value: '', valid: true, error: '', validators: [] },
        address: { value: '', valid: true, error: '', validators: [] },
        notes: { value: '', valid: true, error: '', validators: [] },
    });

    const [formLoading, setFormLoading] = useState(false);
    const [formValid, setFormValid] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');

    const selectedSite = sites.find(site => site.value === clientForm.site_id.value) || null;

    useEffect(() => {
        postApi(sitesList, {}).then((response) => {
            const sitesData = (response.data?.data || response.data || []);
            const siteOptions = sitesData.map(site => ({
                value: site._id || site.id,
                label: site.name
            }));
            if (sitesData.length === 0) {
                siteOptions.push({ value: 'create-site', label: 'Create Site' });
            }
            setSites(siteOptions);
        }).catch((error) => {
            console.log("Failed to load sites", error);
        });
    }, []);

    useEffect(() => {
        if (clientId && isEdit) {
            setInitialLoading(true);
            getApi(`${clientDetail}/${clientId}`).then((response) => {
                let data = response.data;
                setClientForm(prevState => {
                    return Validators.validateAndSetAllFormControls(prevState, data)
                })
                setInitialLoading(false);
            }).catch((error) => {
                console.log(error);
                setInitialLoading(false);
            });
        }
    }, [clientId, isEdit]);

    useEffect(() => {
        setFormValid(Validators.validateForm(clientForm));
    }, [clientForm]);

    const inputChange = (type, event) => {
        if (type === 'site_id') {
            if (event?.value === 'create-site') {
                props.history.push('/sites/add');
                return;
            }
            setClientForm(prevState => {
                return {
                    ...prevState,
                    [type]: Validators.validateFormControl(prevState[type], event?.value || '')
                }
            })
        } else {
            setClientForm(prevState => {
                return {
                    ...prevState,
                    [type]: Validators.validateFormControl(prevState[type], event.target.value)
                }
            })
        }
    };

    const onCancel = () => {
        props.history.goBack();
    }

    const onSaveClient = () => {
        setFormLoading(true);
        let data = {
            "name": clientForm.name.value,
            "company_name": clientForm.company_name.value,
            "site_id": clientForm.site_id.value,
            "email": clientForm.email.value,
            "mobile": clientForm.mobile.value,
            // "gstnumber": clientForm.gstnumber.value,
            // "address": clientForm.address.value,
            // "notes": clientForm.notes.value
        };

        if (isEdit) {
            // Backend expects PUT /api/clients/{client_id} without id in payload
            putApi(`${clientsAdd}${clientId}`, data).then((response) => {
                if (response.data?.updated || response.status === 200) {
                    props.history.goBack();
                }
                setFormLoading(false);
            }).catch((error) => {
                setFormLoading(false);
                setErrorMessage(error.response.data.detail);
                setTimeout(() => {
                    setErrorMessage('');
                }, 3000);
            })
        } else {
            postApi(clientsAdd, data).then((response) => {
                if (response.status === 200) {
                    props.history.goBack();
                }
                setFormLoading(false);
            }).catch((error) => {
                setFormLoading(false);
                setErrorMessage(error.response.data.detail);
                setTimeout(() => {
                    setErrorMessage('');
                }, 3000);
            })
        }
    }

    return (
        <>
            <div className="mt-5">
                <div className="client-add-edit-container container">
                    <div className="page-header">
                        <h4 className="page-title">
                            <ClientIcon color="#9333ea" />{isEdit ? "Edit Client" : "Add New Client"}
                        </h4>
                        <p className="page-subtitle">Enter client details to {isEdit ? "update" : "add"} a client</p>
                    </div>
                    {
                        initialLoading ? (
                            <div className="loader-container">
                                <img className='loader-icon' src={`${process.env.PUBLIC_URL}/static/images/loader.svg`} alt="loader-icon" />
                            </div>
                        ) : (
                            <>
                                <div className="form-cards-container">

                                 
                                    <div className="form-card">
                                        <div className="inline-fields">
                                            <div className="inline-field">
                                                <div className="field-label">
                                                    <span className="field-icon"><UserIcon color="#6b7280" /></span>
                                                    CLIENT NAME<span className="required-asterisk">*</span>
                                                </div>
                                                <TextInput className="form-fontsize" type={'text'} name={'name'} label={''} placeholder={'Enter Client Name'}
                                                    value={clientForm.name.value} error={clientForm.name.error} onChange={(event) => inputChange("name", event)} />
                                            </div>
                                            <div className="inline-field">
                                                <div className="field-label">
                                                    <span className="field-icon"><BuildingIcon color="#6b7280" /></span>
                                                    COMPANY NAME<span className="required-asterisk">*</span>
                                                </div>
                                                <TextInput className="form-fontsize" type={'text'} name={'company_name'} label={''} placeholder={'Company Name'}
                                                    value={clientForm.company_name.value} error={clientForm.company_name.error} onChange={(event) => inputChange("company_name", event)} />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="form-card">
                                        <div className="inline-fields">
                                            <div className="inline-field">
                                                <div className="field-label">
                                                    <span className="field-icon"><BuildingIcon color="#6b7280" /></span>
                                                    SITE<span className="required-asterisk">*</span>
                                                </div>
                                                <Select className="form-fontsize" name={'site_id'} placeholder={'Select a site'}
                                                    value={selectedSite}
                                                    options={sites}
                                                    onChange={(selectedOption) => inputChange("site_id", selectedOption)}
                                                    isSearchable />
                                                {clientForm.site_id.error && <div className="text-danger" style={{ minHeight: '18px', fontSize: '12px', marginTop: '4px' }}>{clientForm.site_id.error}</div>}
                                            </div>
                                            <div className="inline-field">
                                                <div className="field-label">
                                                    <span className="field-icon"><PhoneIcon color="#6b7280" /></span>
                                                    MOBILE NUMBER<span className="required-asterisk">*</span>
                                                </div>
                                                <TextInput className="form-fontsize" type={'number'} name={'mobile'} label={''} placeholder={'Phone Number'}
                                                    value={clientForm.mobile.value} error={clientForm.mobile.error} onChange={(event) => inputChange("mobile", event)} />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="form-card">
                                         <div className="inline-fields">
                                            <div className="inline-field">
                                        <div className="field-label">
                                            <span className="field-icon"><EmailIcon color="#6b7280" /></span>
                                            EMAIL ADDRESS<span className="required-asterisk">*</span>
                                        </div>
                                        <TextInput className="form-fontsize" type={'text'} name={'email'} label={''} placeholder={'Email Address'}
                                            value={clientForm.email.value} error={clientForm.email.error} onChange={(event) => inputChange("email", event)} />
                                    </div>
                                    <div className="inline-field">
                                                <div className="field-label">
                                                    <span className="field-icon"><FileTextIcon color="#6b7280" /></span>
                                                    GST NUMBER
                                                </div>
                                                <TextInput className="form-fontsize" type={'text'} name={'gstnumber'} label={''} placeholder={'GST registration number'}
                                                    value={clientForm.gstnumber.value} error={clientForm.gstnumber.error} onChange={(event) => inputChange("gstnumber", event)} />
                                            </div>
                                            </div>
                                    </div>

                                    <div className="form-card">
                                        <div className="inline-fields">
                                            <div className="inline-field">
                                        <div className="inline-fields">
                                            
                                            <div className="inline-field">
                                                <div className="field-label">
                                                    <span className="field-icon"><LocationIcon color="#6b7280" /></span>
                                                    ADDRESS
                                                </div>
                                                <TextAreaInput className="form-fontsize" name={'address'} label={''} placeholder={'Client Address'} style={{ "minHeight": "5rem" }}
                                                    value={clientForm.address.value} error={clientForm.address.error} onChange={(event) => inputChange("address", event)} />
                                            </div>

                                             <div className="form-card">
                                        <div className="field-label">
                                            <span className="field-icon"><FileTextIcon color="#6b7280" /></span>
                                            NOTES
                                        </div>
                                        <TextAreaInput className="form-fontsize" name='notes' label={''} placeholder='Additional notes about this client......' style={{ "minHeight": "5rem" }}
                                            value={clientForm.notes.value} error={clientForm.notes.error} onChange={(event) => inputChange("notes", event)} />
                                    </div>
                                    </div>

                                        </div>

                                    

                                   
                                </div>
                            </div>
                            </div>

                            {errorMessage && (
                                    <div className="error-message">{errorMessage}</div>
                                )}

                                <div className="form-actions">
                                    <button className="btn-cancel" onClick={onCancel}>
                                        Cancel
                                    </button>
                                    <button className="btn btn-solid-blue fw-bold" onClick={onSaveClient} disabled={!formValid}>
                                        <PlusIcon />{isEdit ? "Update Client" : "Add Client"} {formLoading ? <Spinner className='ms-2' as="span" animation="border" role="status" aria-hidden="true" /> : ''}
                                    </button>
                                </div>
                            </>
                        )
                    }
                </div>
            </div>
        </>
    )
}